/**
 * Copyright (c) 2025 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';

export type CheckmarkFilledIconProps = {
  size?: number | string;
  color?: string;
};
            
/**
 * Defines the Design Language System (DLS) Checkmark Filled Icon component.
 */
export const CheckmarkFilledIcon = ({size = 60, color = dlsColor('caBlue')}: CheckmarkFilledIconProps) => {
  return (
    <svg width={size} height={size} viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="30" cy="30" r="28" fill={color} stroke={dlsColor('white')} strokeWidth="4"/>
      <path d="M25.1928 36.1054L20.3487 31.2613C19.5693 30.4819 18.3063 30.4797 17.5241 31.2563C16.738 32.0369 16.7357 33.3076 17.5191 34.0909L23.4249 39.9967C24.4012 40.973 25.9841 40.973 26.9604 39.9967L42.4884 24.4687C43.2679 23.6892 43.2679 22.4255 42.4884 21.6461C41.7092 20.8669 40.446 20.8666 39.6665 21.6454L25.1928 36.1054Z" fill={dlsColor('white')} stroke={dlsColor('white')}/>
    </svg>
  );
};

export default React.memo(CheckmarkFilledIcon);
